import { render, staticRenderFns } from "./chartTitle.vue?vue&type=template&id=27b2462a&scoped=true&"
import script from "./chartTitle.vue?vue&type=script&lang=js&"
export * from "./chartTitle.vue?vue&type=script&lang=js&"
import style0 from "./chartTitle.vue?vue&type=style&index=0&id=27b2462a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b2462a",
  null
  
)

export default component.exports